var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircularIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 10C18.5 14.6944 14.6944 18.5 10 18.5C5.30558 18.5 1.5 14.6944 1.5 10C1.5 5.30558 5.30558 1.5 10 1.5C14.6944 1.5 18.5 5.30558 18.5 10ZM20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10.1034 4.66667C10.3737 4.66667 10.5928 4.88574 10.5928 5.15598V9.51101H14.9475C15.2177 9.51101 15.4368 9.73009 15.4368 10.0003C15.4368 10.2706 15.2177 10.4896 14.9475 10.4896L10.5928 10.4896V14.844C10.5928 15.1143 10.3737 15.3333 10.1035 15.3333C9.83321 15.3333 9.61414 15.1143 9.61414 14.844V10.4896L5.25944 10.4896C4.98919 10.4896 4.77012 10.2706 4.77012 10.0003C4.77012 9.73009 4.98919 9.51101 5.25943 9.51101H9.61414V5.15598C9.61414 4.88574 9.83321 4.66667 10.1034 4.66667Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircularIconOrange);
export default __webpack_public_path__ + "static/media/plus_circular_icon_orange.ccdbfbba370e72e8226116a4d274c00f.svg";
export { ForwardRef as ReactComponent };